import { assetImages } from "constants";
import React from "react";

const AgendaErrorMessageModal = ({ modalMessage, setModalMessage }) => {
  return (
    <div className="conatct_modal success_popup">
      <div
        className="modal fade"
        id="agenda_error_info_modal"
        data-bs-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title"> </h3>
              <button
                type="button"
                className="close rounded-circle"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModalMessage("");
                }}
              >
                <i className="material-icons-outlined text-black">close</i>
              </button>
            </div>
            <div className="modal-body py-4 px-4">
              <div className="success_graphics text-center mb-3">
                <img src={assetImages.alertInfo} alt="" />
              </div>
              <div className="success_text text-center">
                <h3 className="text-uppercase">{modalMessage}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgendaErrorMessageModal;
